import React, { useEffect, useState } from 'react';
import { endpoints } from '../../utils/Constants';
import ManageEntityList from './ManageEntityList';
import {Row, Col, Container} from 'reactstrap';
import FormInput from '../Form/FormInput';
import { useFormikContext } from 'formik';
import RichTextEditor from '../Form/RichTextEditor';
import { useHistory, useParams } from 'react-router-dom';
import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tabs'
import Editor from '../Models/Editor';
import entities from '../../utils/entities';
import { useEdit } from '../../Services/EditContext';
import IFrameContainer from '../Editors/IFrameContainer';
import LoadingAnimation from '../Form/LoadingAnimation';
import useFetch from '../../Services/useFetch';
import dayjs from 'dayjs';
import { showDateTimeUTC } from '../../utils/Helpers';
const ViewMessageLogItem = ({ route }) => {
    const { values } = useFormikContext();
    const isRich = values.notificationType === 'Email';
    const { message, emailTemplate, emailHeader } = values;
    const [wrappedMessage, setWrappedMessage] = useState();
    const [template, loadingTemplate, errorTemplate] = useFetch(emailTemplate ? endpoints.getEmailTemplate + '/' + emailTemplate : null);
    
    useEffect(() => {
        if (template && message && emailTemplate) {
            const { value } = template;
            const wrapped = value.replace("{content}", message);
            
            const wrappedHeader = wrapped.replace("{Email Header}", emailHeader ? emailHeader : "").replaceAll('<img alt="JetBidders" />', '<img alt="JetBidders" src="./img/EmailLogo.png" />');
            setWrappedMessage(wrappedHeader);

        }
    }, [template, message, emailTemplate, emailHeader]);
    const [edit] = useEdit();
    return <React.Fragment>
        <Container>
            <Row>
                <Col>
                    <FormInput noEdit id='name' label='name' />
                </Col>
                <Col>
                    <FormInput noEdit id='notificationType' label="Notification Type" />
                </Col>
            </Row>

            <Row>
                <Col>
                    <Row>
                        <FormInput noEdit id='user.fullname' label='Requested By'/>
                    </Row>
                    <Row>

                        <Col>
                            <FormInput noEdit id='entityType' label='Item' />
                        </Col>
                        <Col>
                            <FormInput noEdit id='fromState' label='From' />
                        </Col>
                        <Col>
                            <FormInput noEdit id='newState' label='To' />
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <FormInput noEdit id='toEmail' label='To' />
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <FormInput id='subject' label='Subject' />
                        </Col>
                    </Row>
                    <Row>
                        <Col >
                            {isRich ? (edit ? <RichTextEditor id='message' label='Message' /> : <IFrameContainer content={loadingTemplate ? <LoadingAnimation /> : (wrappedMessage ? wrappedMessage : message)} /> ): <FormInput id='message' label='Message' />}
                            {errorTemplate?<h3>Error loading Template</h3>:null}
                        </Col>
                    </Row>

                    <Row>
                        <Col>
                            <FormInput noEdit id='targetAudience' label="To"  />
                        </Col>
                    </Row>
                </Col>
            </Row>
            <Row>
                {values.createdAt ? <div style={{ fontSize: 'small' }}>Created At:{showDateTimeUTC(values.createdAt)}</div> : null}
                {values.sentAt ? <div style={{ fontSize: 'small' }}>Sent At:{showDateTimeUTC(values.sentAt)}</div> : null}
            </Row>
        </Container>


    </React.Fragment>
}

const MessageLog = ({ getAllMessages, parentHeight, route, itemParam }) => {
    const [dateFrom, setFromState] = useState(dayjs().subtract(1, 'day').format("YYYY-MM-DD"));
    const [dateTo, setToState] = useState(dayjs().add(2, 'day').format("YYYY-MM-DD"));
    const params = useParams();
    const [entity, setEntity] = useState();
    const setFrom = (e) => {
        setFromState(dayjs(e).format("YYYY-MM-DD"));
    }

    const setTo = (e) => {
        setToState(dayjs(e).format("YYYY-MM-DD"));
    }

    useEffect(() => {
        if (dateFrom && dateTo && getAllMessages) {
            setEntity({ ...entities.messageLog, getByStatus: () => getAllMessages + dateFrom + "/" + dateTo })
        }
    }, [dateFrom, dateTo, getAllMessages])
    return entity ? <ManageEntityList id={params[itemParam]} route={route} entity={entity} parentHeight={parentHeight} dateFrom={dateFrom} dateTo={dateTo} fromChange={setFrom} toChange={setTo}/> : null;
}

const ViewMessageLogModal = () => {
    const { messageId } = useParams();
    const history = useHistory();
    const close = () => {
        const newPath = history.location.pathname.substr(0, history.location.pathname.lastIndexOf('/') );
        history.push(newPath);
    }
    return <Editor entity={entities.messageLog} itemId={messageId} editorClosed={close}><ViewMessageLogItem /></Editor>
}
const AdminMessageLog = ({ parentHeight , route }) => <MessageLog route={route}  getAllMessages={endpoints.getAllMessages} parentHeight={parentHeight}/>
const ClientStaffMessageLog = ({ route, parentHeight,clientStaffId }) => {
    const params = useParams(); 
    const paramId = params.list && params.list === 'Staff' ? 'clientDepartmentId' : params.list && params.list === 'Department' ? 'clientStaffId' : 'messageId';
    const listId = params.list && params.list === 'Staff' ? params.clientId : params.list && params.list === 'Department' ? params.clientDepartmentId : params.list === 'Client' ? params.clientStaffId : clientStaffId ? clientStaffId : params.clientStaffId;
    return <MessageLog route={route} itemParam={paramId} parentHeight={parentHeight} getAllMessages={endpoints.getAllClientStaffMessages + listId + '/'} />
}
const SupplierMessageLog = ({ route, supplierId, parentHeight }) => {
 return <MessageLog route={route} itemParam='supplierId' parentHeight={parentHeight} getAllMessages={endpoints.getSupplierMessages + supplierId + '/'} />
}
const ClientMessageLog = ({ route, parentHeight, clientId }) => {
    
    return <Tabs defaultActiveKey={'All'} >

        <Tab key={'All'} eventKey={'All'} title='All' style={{ height: '400px' }} >
            <MessageLog parentHeight={parentHeight} itemParam='clientId' route={route} getAllMessages={endpoints.getAllClientMessages + clientId + '/'} />
        </Tab>
        <Tab key={'Me'} eventKey={'Me'} title='Me' style={{ height: '400px' }} >
            <MessageLog parentHeight={parentHeight} itemParam='clientId' route={route} getAllMessages={endpoints.getOnlyClientMessages + clientId + '/'} />
        </Tab>

    </Tabs >
};

const ClientDepartmentMessageLog = ({ route, clientDepartmentId, parentHeight,itemParam }) => {
    
    
    return <Tabs defaultActiveKey={'All'} >

        <Tab key={'All'} eventKey={'All'} title='All' >
            <MessageLog itemParam={itemParam} route={route} parentHeight={parentHeight} getAllMessages={endpoints.getAllClientDepartmentMessages + clientDepartmentId + '/'} />
        </Tab>
        <Tab key={'Me'} eventKey={'Me'} title='Me' style={{ height: '400px' }} >
            <MessageLog itemParam={itemParam} route={route} parentHeight={parentHeight}  getAllMessages={endpoints.getOnlyClientDepartmentMessages + clientDepartmentId + '/'} />
        </Tab>

    </Tabs >
}
    
export { ViewMessageLogItem,ViewMessageLogModal,AdminMessageLog, ClientMessageLog, ClientDepartmentMessageLog, ClientStaffMessageLog, SupplierMessageLog};